import React from 'react';
import PropTypes from 'prop-types';
import { Mixpanel } from '../../Mixpanel';

import './style.scss';

function getNumberOfHachathonsByTag(tagName, hackathons) {
  let numberOfHackathonsByTag = 0;
  if (tagName === 'Все') {
    numberOfHackathonsByTag = hackathons.length;
  } else {
    numberOfHackathonsByTag = hackathons.reduce((acc, curr) => curr.tags.indexOf(tagName) > -1 ? acc + 1 : acc, 0);
  }
  return numberOfHackathonsByTag;
}

const HackNavigation = (props) => {
  return (
    <div className='organizers-btn-wrapper'>
      <div className='left-btns-block'>
        <div className='org-btn__find'></div>
        {
          ['Все', ...props.tags].map((tagName) => {
            const numberOfHackathonsByTag = getNumberOfHachathonsByTag(tagName, props.hackathons);
            return (
              <div className={props.selectedTag === tagName ? 'org-btn org-btn_active' : 'org-btn'}
                onClick={() => {Mixpanel.track('Hackathons', {'Change filter' : tagName}); props.onTagChange(tagName)}}
                key={tagName + numberOfHackathonsByTag}>
                <div className='org-btn__name'>{tagName}</div>
                <div className='org-btn__counter'>{numberOfHackathonsByTag}</div>
                <div className='marker'></div>
              </div>
            )
          })
        }
      </div>
      {/* <div className='right-btns-block'>Хакатоны Везде</div> */}
    </div>
  )
}

HackNavigation.propTypes = {
  selectedTag: PropTypes.string.isRequired,
  hackathons: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  onTagChange: PropTypes.func.isRequired,
}

export default HackNavigation;


// WEBPACK FOOTER //
// ./src/components/Hackathons/HackNavigation/index.js